import axios from "axios";
import _ from "lodash";
import config from "../config";

export default class LeadService {
  static registerLead(stateName, mobile, remarks) {
    return axios.post(`${config.leadServiceUrl}`, {
      state: _.startCase(stateName),
      source: "GL_PWA",
      customerPhoneNumber: mobile,
      skuCode: "AGS-SC-159",
      skuName: "AgroStar Gold Service Live Combo 2 (6 Months)",
      remarks: remarks,
    });
  }

  static registerLeadDelayed(stateName, mobile, remarks) {
    return axios.post(`${config.baseUrl}/lead/register`, {
      state: _.startCase(stateName),
      source: "GL_PWA",
      customerPhoneNumber: mobile,
      skuCode: "AGS-SC-159",
      skuName: "AgroStar Gold Service Live Combo 2 (6 Months)",
      remarks: remarks,
    });
  }
}
